import _objectSpread from "/app/src/Web/InternetBranch/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import router from "./router/router";
import store from "./store";
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken } from '@/utils/auth'; // getToken from cookie

NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

// permission judge functionS
function hasPermission(accessible, to) {
  var canAccess = true;
  if (accessible && accessible.length > 0) {
    accessible.forEach(function (element) {
      // if(element.path && to.path && to.path.includes(element.path)) return true
      if (element.name === to.name) {
        canAccess = true;
      }
      if (element.children) {
        element.children.forEach(function (el) {
          if (el.name === to.name) {
            canAccess = true;
          }
        });
      }
    });
  }
  return canAccess;
}
var whiteList = ['/login', '/auth-redirect', '/result', '/verifyEmail', '/referenceApproval', '/paymentdate', '/successpayment', '/failpayment', '/permissionUpdate']; // no redirect whitelist

router.beforeEach(function (to, from, next) {
  NProgress.start(); // start progress bar
  if (whiteList.some(function (r) {
    return to.path.indexOf(r) > -1;
  })) {
    next();
    NProgress.done();
    return;
  }
  var token = getToken();
  if (token) {
    // determine if there has token
    /* has token*/
    if (to.path === '/login') {
      next({
        path: '/'
      });
      NProgress.done(); // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if (store.getters.roles.length === 0) {
        // 判断当前用户是否已拉取完user_info信息
        store.dispatch('GetUserInfo').then(function () {
          // 拉取user_info
          router.addRoutes(router.options.routes); // 动态添加可访问路由表
          next(_objectSpread(_objectSpread({}, to), {}, {
            replace: true
          })); // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
        }).catch(function (err) {
          console.log(to, from);
          store.dispatch('FedLogOut').then(function () {
            if (from.path !== '/') {
              Message.error(err || 'Verification failed, please login again');
            }
            next({
              path: '/login'
            });
          });
        });
        // store.dispatch('GetParameterTypes')
      } else {
        if (hasPermission(store.getters.permission_routers, to)) {
          next();
        } else {
          next({
            path: '/401',
            replace: true,
            query: {
              noGoBack: true
            }
          });
        }
        // 可删 ↑
      }
    }
  } else {
    /* has no token*/
    if (to.path.indexOf('/result/') !== -1) {
      next();
      return;
    }
    if (to.path.indexOf('/appointment/') !== -1) {
      next();
      return;
    }
    if (whiteList.some(function (r) {
      return to.path.indexOf(r) > -1;
    })) {
      // 在免登录白名单，直接进入
      next();
    } else {
      next("/login?redirect=".concat(to.path));
      NProgress.done();
    }
  }
});
router.afterEach(function () {
  NProgress.done(); // finish progress bar
});